function typeToIcon(type) {
  const map = {
    author: 'person',
    blog: 'folder',
    section: 'folder',
    microsite: 'folder',
    tag: 'label',
    community: 'my_location',
    province: 'my_location',
    area: 'my_location',
    city: 'my_location',
  };
  return map[type] || 'folder';
}

const geoTypes = ['province', 'community', 'area', 'city'];

export {
  typeToIcon,
  geoTypes,
};
